module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFAHv/////9d5I8gAAAAJ0Uk5T/wDltzBKAAAAN0lEQVR42mJgBAMGGIDwUISgogxoYmBhBgwxsCADBsAqOMQBdm8yEiWIJZAZYCHPiBrwjAABBgAziQA61qaEWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cursor.png
// module id = KELv
// module chunks = 1